<script setup lang="ts">
import AbstractWidget from '~/modules/WidgetsAndHooks/runtime/AbstractWidget.vue'

import HookNameEnum from '~/enums/widgets/HookNameEnum'
import type { HookWidgetInterface } from '~/types/widgets/widgetTypes'
import { requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'

const props = defineProps({
  name: {
    type: String,
    required: true,
    validator(value: HookNameEnum) {
      return Object.values(HookNameEnum).includes(value as HookNameEnum)
    },
  },
  class: {
    type: String,
    required: false,
    default: '',
  },
})

const hookWidgets = await useFetch('/api/hooks/getWidgets', {
  method: 'POST',
  body: {
    hookName: props.name,
  },
  key: props.name,
  headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
  lazy: true,
})

function makeWidgetElementKey(widget: HookWidgetInterface): string {
  return `widget_${widget.id}`
}
</script>

<template>
  <ClientOnly>
    <div v-for="widget in hookWidgets.data.value" :key="makeWidgetElementKey(widget)" :class="props.class">
      <AbstractWidget :widget="widget" />
    </div>
  </ClientOnly>
</template>
